// These constants are calculated based on the font metrics for Noto Color Emoji
// SCALE_EMOJI: based on experimentation
export const SCALE_EMOJI = 0.918;
// EMOJI_ADVANCE_RATIO: advance width / height ratio (1275/1200 = 1.0625)
export const EMOJI_ADVANCE_RATIO = 1.0625;
// EMOJI_X_OFFSET_RATIO: horizontal offset as fraction of emoji size (moves emoji right)
export const EMOJI_X_OFFSET_RATIO = 0.03;
// EMOJI_Y_OFFSET_RATIO: vertical offset as fraction of lineHeight (moves emoji up when reduced)
export const EMOJI_Y_OFFSET_RATIO = 0.1;
